export const GET_LIST_QUESTIONS_WATCHER =
  "app/ReportsV2/WidgetQualitativeQuestion/GET_LIST_QUESTIONS_WATCHER"
export const GET_LIST_QUESTIONS_SUCCESS =
  "app/ReportsV2/WidgetQualitativeQuestion/GET_LIST_QUESTIONS_SUCCESS"
export const GET_LIST_QUESTIONS_FAILED =
  "app/ReportsV2/WidgetQualitativeQuestion/GET_LIST_QUESTIONS_FAILED"

export const GET_LIST_ONLY_QUESTIONS_SUCCESS =
  "app/ReportsV2/WidgetQualitativeQuestion/GET_LIST_ONLY_QUESTIONS_SUCCESS"
export const GET_LIST_ONLY_QUESTIONS_FAILED =
  "app/ReportsV2/WidgetQualitativeQuestion/GET_LIST_ONLY_QUESTIONS_FAILED"
